"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.notificationSchema = exports.bulkMessageFormSchema = exports.directMessageFormSchema = exports.NotificationStatus = exports.NotificationType = void 0;
const yup = __importStar(require("yup"));
var NotificationType;
(function (NotificationType) {
    NotificationType["SMS"] = "sms";
    NotificationType["EMAIL"] = "email";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["INITIATED"] = "INITIATED";
    NotificationStatus["DISPATCHED"] = "DISPATCHED";
    NotificationStatus["FAILED"] = "FAILED";
    NotificationStatus["SUCCESS"] = "SUCCESS";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
exports.directMessageFormSchema = yup.object().shape({
    to: yup.string().required(),
    body: yup
        .string()
        .when('type', {
        is: NotificationType.SMS,
        then: yup.string().max(160, 'SMS body cannot exceed 160 characters').required(),
        otherwise: yup.string().required()
    })
        .required()
        .label('Message'),
    type: yup.mixed().oneOf(Object.values(NotificationType)).required()
});
exports.bulkMessageFormSchema = yup.object().shape({
    categories: yup.array().of(yup.string().required()).required().label('Category'),
    body: yup
        .string()
        .when('type', {
        is: NotificationType.SMS,
        then: yup.string().max(160, 'SMS body cannot exceed 160 characters').required(),
        otherwise: yup.string().required()
    })
        .required()
        .label('Message'),
    type: yup.mixed().oneOf(Object.values(NotificationType)).required()
});
exports.notificationSchema = yup.object().shape({
    account: yup.string().required(),
    subject: yup.string().notRequired(),
    body: yup
        .string()
        .when('type', {
        is: NotificationType.SMS,
        then: yup.string().max(160, 'SMS body cannot exceed 160 characters').required(),
        otherwise: yup.string().required()
    })
        .required(),
    sentDate: yup.date().notRequired(),
    type: yup.mixed().oneOf(Object.values(NotificationType)).required(),
    receiver: yup
        .object()
        .shape({
        to: yup.array().of(yup.object().shape({
            id: yup.string().required(),
            name: yup.string().notRequired()
        }))
    })
        .required(),
    status: yup.mixed().oneOf(Object.values(NotificationStatus)).notRequired()
});
